const peiTransitionAges = {
  TwoAndSevenMonth: 2.58,
  Six: 6,
  Fourteen: 14,
  Fiftteen: 15,
  Sixteen: 16,
};

export default peiTransitionAges;
